module.exports = __webpack_public_path__ + "static/media/bookshare-Logo.7f1c44a6.png";